module.exports = __webpack_public_path__ + "img/ooo-she-thicc.ed1a1e0c.svg";